import { useRef, useState } from "react";
import { NotificationsPopover } from "Components/Layout/UserHeader/Notifications/NotificationsPopover";
import { NotificationsBadge } from "Components/Layout/UserHeader/Notifications/NotificationsBadge";
import { useNewNotificationsCount } from "Api/Queries/Notifications/useNewNotificationsCount";

type Props = {
  colorVariant: "light" | "dark";
};

export const NotificationWithPopover = ({ colorVariant = "light" }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const badgeRef = useRef<HTMLDivElement>(null);
  const { data } = useNewNotificationsCount();

  const notificationsCount = data?.count || 0;

  return (
    <>
      <NotificationsBadge
        badgeRef={badgeRef}
        colorVariant={colorVariant}
        notificationsCount={notificationsCount}
        onPopupOpenRequested={() => setIsOpen(true)}
      />
      <NotificationsPopover
        isOpen={isOpen}
        anchorEl={badgeRef.current}
        onClose={() => setIsOpen(false)}
        notificationsCount={notificationsCount}
      />
    </>
  );
};
